(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black26-offers"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!window.black26CopyInitialized) {
    window.black26CopyInitialized = true;
    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-b26-copy]');
      if (!button) return;
      const code = button.dataset.b26Copy;
      const status = button.closest('.b26-offer').querySelector('[data-copy-status]');
      try {
        await navigator.clipboard.writeText(code);
        status.textContent = button.dataset.success;
      } catch {
        const range = document.createRange();
        range.selectNodeContents(button.previousElementSibling);
        const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range);
        status.textContent = code;
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-button"] && !Shopify.designMode) return;
  try {
    
  if (!window.customLoginButtonInitialized) {
    window.customLoginButtonInitialized = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-custom-login-button]');
      if (!button) return;
      const notice = button.closest('.custom-button').querySelector('.custom-button__notice');
      if (!notice) return;
      notice.hidden = false;
      button.setAttribute('aria-expanded', 'true');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals-pill-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pill-tabs-overflow')) {
    customElements.define('pill-tabs-overflow', class extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('scrollable-content');
        this.inner = this.querySelector('.tabs-nav__scroller-inner');
        if (!this.scroller || !this.inner) return;
        this.updateEdges = () => {
          const viewport = this.scroller.getBoundingClientRect();
          const content = this.inner.getBoundingClientRect();
          this.style.setProperty('--fade-left', `${Math.min(28, Math.max(0, viewport.left - content.left))}px`);
          this.style.setProperty('--fade-right', `${Math.min(28, Math.max(0, content.right - viewport.right))}px`);
        };
        this.scroller.addEventListener('scroll', this.updateEdges, { passive: true });
        this.resizeObserver = new ResizeObserver(this.updateEdges);
        this.resizeObserver.observe(this.scroller);
        this.resizeObserver.observe(this.inner);
        this.updateEdges();
      }
      disconnectedCallback() {
        this.scroller?.removeEventListener('scroll', this.updateEdges);
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspire-product-accordion"] && !Shopify.designMode) return;
  try {
    
    (function () {
        function isMobileDevice() {
            const ua = navigator.userAgent || navigator.vendor || window.opera;
            const mobileRegex = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|windows phone|phone|webos|kindle|tablet/i;
            return mobileRegex.test(ua.toLowerCase());
        }

        const pcHandle = () => {
            const cardList = document.querySelectorAll('.accordion-card');
            cardList.forEach((node) => {
                node.addEventListener('click', () => {
                    cardList.forEach(item => item.classList.remove('active'))
                    node.classList.add('active');
                }, {
                    passive: false
                })
            })
        }
        const mobileHandle = () => {
            const swipeArea = document.querySelector('.accordion-content');

            const cartList = swipeArea.querySelectorAll(".accordion-card");
            const dotList = document.querySelectorAll(".accordion-content-dot .item");

            let current = 0;
            const swipe = (current, newCur, dir) => {
                const x = dir === 'left' ? 'translateX(-100vw)' : 'translateX(100vw)';
                cartList[current].classList.remove('active');
                cartList[current].setAttribute('style', 'transform: ' + x + ';transition: transform .4s ease-in-out;z-index:3');
                setTimeout(() => {
                    cartList[current].removeAttribute('style');
                }, 400)
                cartList[newCur].classList.add('active');
                // 小圆点
                dotList[current].classList.remove('active');
                dotList[newCur].classList.add('active');
            }

            let startX = 0;
            // 触摸开始
            swipeArea.addEventListener('touchstart', e => {
                startX = e.touches[0].clientX; // 记录起始X坐标
            });

            // 触摸结束
            swipeArea.addEventListener('touchend', e => {              
                const endX = e.changedTouches[0].clientX; // 结束X坐标
                const diffX = endX - startX;
                const threshold = 50; // 滑动阈值（像素）
                let newCur = current;
                const maxCur = cartList.length - 1;
                let dir = 'left'
                if (Math.abs(diffX) > threshold) {
                    e.preventDefault();
                    if (diffX > 0) {
                        newCur = current - 1;
                        if (newCur < 0) newCur = maxCur;
                        dir = 'right'
                    } else {
                        newCur = current + 1;
                        if (newCur > maxCur) newCur = 0;
                        dir = 'left'
                    }
                    swipe(current, newCur, dir);
                    current = newCur;
                }
            });
        }

        if (isMobileDevice()) {
            mobileHandle();
        } else {
            pcHandle();
        }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspire-product-anchor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initialize(anchorDom) {
      const content = anchorDom?.querySelector('.anchor-tab-content');
      if (!content) return;
      const tabs = Array.from(content.querySelectorAll('.anchor-tab-item'));
      const anchors = Array.from(document.querySelectorAll('[data-anchor]'));
      let animationFrame = null;
      let updateFrame = null;
      let scrolling = false;
      const getTop = (element) => element.getBoundingClientRect().top + window.scrollY;
      const main = document.getElementById('main');
      let headerOffset = null;
      const isScrollLocked = () => {
        const rootStyle = getComputedStyle(document.documentElement);
        const bodyStyle = getComputedStyle(document.body);
        return ['hidden', 'clip'].includes(rootStyle.overflowY)
          || ['hidden', 'clip'].includes(bodyStyle.overflowY)
          || rootStyle.position === 'fixed'
          || bodyStyle.position === 'fixed';
      };
      const getOffset = () => {
        const locked = isScrollLocked();
        let offset = 0;
        if (locked) {
          for (let element = main; element; element = element.offsetParent) {
            if (element === document.documentElement) break;
            if (element === document.body && getComputedStyle(element).position === 'fixed') break;
            offset += element.offsetTop;
          }
        } else if (main) {
          offset = Math.max(0, getTop(main));
        }
        if (offset !== headerOffset) {
          headerOffset = offset;
          content.style.setProperty('--inspire-header-offset', `${offset}px`);
        }

        return offset;
      };
      const indicator = document.createElement('span');
      indicator.className = 'anchor-tab-indicator';
      indicator.setAttribute('aria-hidden', 'true');
      content.appendChild(indicator);
      let activeTab = tabs.find((tab) => tab.classList.contains('active'));
      function moveIndicator() {
        if (!activeTab) {
          indicator.hidden = true;
          return;
        }
        const range = document.createRange();
        range.selectNodeContents(activeTab);
        const text = range.getBoundingClientRect();
        const tab = activeTab.getBoundingClientRect();
        indicator.hidden = false;
        const parent = indicator.offsetParent;
        if (!parent) return;
        const origin = parent.getBoundingClientRect();
        indicator.hidden = false;
        indicator.style.width = `${text.width}px`;
        indicator.style.transform = `translateX(${text.left - origin.left - parent.clientLeft + parent.scrollLeft}px)`;
        indicator.style.top = `${tab.bottom - origin.top - parent.clientTop + parent.scrollTop - 3}px`;
        anchorDom.classList.add('has-underline');
      }
      function select(tab) {
        const changed = activeTab !== tab;
        activeTab = tab;
        tabs.forEach((item) => {
          const active = item === tab;
          if (item.classList.contains('active') !== active) item.classList.toggle('active', active);
        });
        if (changed) moveIndicator();
      }
      function update() {
        updateFrame = null;
        if (isScrollLocked()) {
          cancelScroll();
          getOffset();
          moveIndicator();
          return;
        }
        const position = window.scrollY > getTop(anchorDom) - getOffset() ? 'fixed' : '';
        if (content.style.position !== position) {
          content.style.position = position;
          moveIndicator();
        }
        if (scrolling || !anchors.length) return;
        const threshold = window.scrollY + window.innerHeight * 0.6;
        let current = anchors[0];
        for (const anchor of anchors) {
          if (getTop(anchor) > threshold) break;
          current = anchor;
        }
        select(tabs.find((tab) => tab.dataset.tab === current.dataset.anchor));
      }
      function scheduleUpdate() {
        if (updateFrame === null) updateFrame = requestAnimationFrame(update);
      }
      function cancelScroll() {
        if (animationFrame !== null) cancelAnimationFrame(animationFrame);
        animationFrame = null;
        scrolling = false;
      }
      function smoothScrollTo(target) {
        cancelScroll();
        const start = window.scrollY;
        target = Math.max(0, Math.min(target, document.documentElement.scrollHeight - window.innerHeight));
        const distance = target - start;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(distance) < 1) {
          window.scrollTo({ top: target, behavior: 'instant' });
          return;
        }
        const duration = Math.min(950, Math.max(400, Math.abs(distance) * 0.18));
        let started = null;
        scrolling = true;
        function animate(time) {
          if (isScrollLocked()) {
            cancelScroll();
            return;
          }
          if (started === null) started = time;
          const progress = Math.min(1, (time - started) / duration);
          const eased = progress * progress * progress * (progress * (progress * 6 - 15) + 10);
          window.scrollTo({ top: start + distance * eased, behavior: 'instant' });
          if (progress < 1) {
            animationFrame = requestAnimationFrame(animate);
          } else {
            animationFrame = null;
            scrolling = false;
            scheduleUpdate();
          }
        }
        animationFrame = requestAnimationFrame(animate);
      }
      content.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-tab]');
        if (!tab || !content.contains(tab)) return;
        const anchor = anchors.find((item) => item.dataset.anchor === tab.dataset.tab);
        if (!anchor) return;
        smoothScrollTo(getTop(anchor) - getOffset() - content.getBoundingClientRect().height);
        select(tab);
      });
      function interrupt() {
        if (!scrolling) return;
        cancelScroll();
        scheduleUpdate();
      }
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('wheel', interrupt, { passive: true });
      window.addEventListener('touchstart', interrupt, { passive: true });
      window.addEventListener('pointerdown', interrupt, { passive: true });
      window.addEventListener('keydown', (event) => {
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) interrupt();
      });
      window.addEventListener('resize', () => {
        cancelScroll();
        scheduleUpdate();
        moveIndicator();
      });
      window.addEventListener('load', scheduleUpdate, { once: true });
      if ('ResizeObserver' in window) {
        const headerObserver = new ResizeObserver(scheduleUpdate);
        document.querySelectorAll('#main, store-header, announcement-bar').forEach((element) => {
          headerObserver.observe(element);
        });
      }
      const scrollLockObserver = new MutationObserver(scheduleUpdate);
      [document.documentElement, document.body].forEach((element) => {
        scrollLockObserver.observe(element, { attributes: true, attributeFilter: ['class', 'style'] });
      });
      getOffset();
      update();
      moveIndicator();
      if (document.fonts) document.fonts.ready.then(moveIndicator);
    }
    function initializeAll() {
      document.querySelectorAll('[id^="InspireProductAnchor-"][data-moving-underline]').forEach(initialize);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspire-product-carousel"] && !Shopify.designMode) return;
  try {
    
  // 轮播
  (function () {
    document.addEventListener('DOMContentLoaded', () => {
      const carouselBox = document.querySelector('.selling-carousel-content');
      const prevBtn = document.querySelector('.selling-carousel-btn.prev');
      const nextBtn = document.querySelector('.selling-carousel-btn.next');

      const setTranslate = (dir) => {
        const width = carouselBox.children[0].clientWidth;
        carouselBox.scrollTo({
          left: carouselBox.scrollLeft + dir * width,
          behavior: 'smooth',
        });
      };
      prevBtn.addEventListener('click', () => {
        setTranslate(-1);
      });
      nextBtn.addEventListener('click', () => {
        setTranslate(1);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspire-product-features"] && !Shopify.designMode) return;
  try {
    
  // 轮播
  (function () {
    function isMobileDevice() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex =
        /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|windows phone|phone|webos|kindle|tablet/i;
      return mobileRegex.test(ua.toLowerCase());
    }

    const pcHandle = () => {
      const warpDom = document.querySelector('.key-features');
      const contentDom = document.querySelector('.key-features-content');
      const descDom = document.querySelector('.key-features-content-desc');
      const pictureDom = document.querySelectorAll('.key-features-content-picture img');
      const descSize = descDom.children?.length;

      let cur = 0; // 当前节点
      const sticky = 200; // 吸顶高度
      window.addEventListener('scroll', () => {
        // if (cur === descSize - 1) return; // 回滚不处理
        // 当前滚动超过距离
        const diff = window.scrollY - (warpDom.offsetTop - sticky);
        // 滚动距离
        const scrollDist = warpDom.clientHeight - contentDom.clientHeight;
        // 切换距离
        const snipDist = Math.ceil(scrollDist / descSize);
        // 计算当前节点
        let nweCur = Math.floor(diff / snipDist);
        nweCur = Math.max(0, Math.min(nweCur, descSize - 1));
        // 切换图片
        pictureDom[cur].classList.remove('active');
        pictureDom[nweCur].classList.add('active');
        // 设置文案节点
        descDom.children[cur].classList.remove('active');
        descDom.children[nweCur].classList.add('active');
        cur = nweCur;
      });
    };

    const mobileHandle = () => {
      const swipeArea = document.querySelector('.key-features-content-desc');
      const cartList = swipeArea.querySelectorAll('.key-features-introduce');
      const imgList = document.querySelectorAll('.key-features-content-picture img');

      let current = 0;
      const swipe = (current, newCur) => {
        const x = newCur * cartList[0].clientWidth + newCur * 20;
        swipeArea.setAttribute('style', 'transform: translateX(-' + x + 'px);transition: transform .4s ease-in-out;');
        // 图片
        imgList[current].classList.remove('active');
        imgList[newCur].classList.add('active');
      };

      let startX = 0;
      // 触摸开始
      swipeArea.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX; // 记录起始X坐标
      });

      // 触摸结束
      swipeArea.addEventListener('touchend', (e) => {
        const endX = e.changedTouches[0].clientX; // 结束X坐标
        const diffX = endX - startX;
        const threshold = 88; // 滑动阈值（像素）
        let newCur = current;
        const maxCur = cartList.length - 1;
        if (Math.abs(diffX) > threshold) {
          if (diffX > 0) {
            // 向右滑动
            newCur = current - 1;
            newCur = Math.max(newCur, 0);
          } else {
            // 向左滑动
            newCur = current + 1;
            newCur = Math.min(newCur, maxCur);
          }
        }
        swipe(current, newCur);
        current = newCur;
      });
    };
    document.addEventListener('DOMContentLoaded', () => {
      if (!isMobileDevice()) {
        pcHandle();
      } else {
        mobileHandle();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["picogo-h2-anchor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', () => {
      const anchorDom = document.querySelector('.anchor-tab');
      const anchorContentDom = document.querySelector('.anchor-tab-content');
      const anchorItemList = document.querySelectorAll('.anchor-tab-item');

      const anchorList = document.querySelectorAll('[data-anchor]');

      const getAnchor = () => {
        const names = [];
        const tops = [];
        anchorList.forEach((item) => {
          names.push(item.getAttribute('data-anchor'));
          tops.push(item.offsetTop);
        });
        return {
          names,
          tops,
        };
      };
      const setClass = (i) => {
        anchorItemList.forEach((item, index) => {
          if (index === i) {
            item.classList.add('active');
            return;
          }
          item.classList.remove('active');
        });
      };
      // 平滑滚动函数
      function smoothScrollTo(targetPosition, duration = 1200) {
        const startPosition = document.documentElement.scrollTop;
        const distance = targetPosition - startPosition;
        let startTime = null;

        function animation(currentTime) {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          document.documentElement.scrollTop = easeOutExpo(timeElapsed, startPosition, distance, duration);

          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          } else {
            document.documentElement.scrollTop = targetPosition;
          }
        }
        function easeOutExpo(t, b, c, d) {
          return t === d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
        }
        requestAnimationFrame(animation);
      }
      anchorContentDom.addEventListener('click', function (e) {
        const tabName = e.target?.getAttribute('data-tab');
        if (!tabName) return;
        const anchor = getAnchor();
        const idx = anchor.names.findIndex((item) => item === tabName);
        // window.scrollTo({
        //     top: anchor.tops[idx] - 70 - 88,
        //     behavior: "smooth",
        // });
        smoothScrollTo(anchor.tops[idx] - 126);
        //  smoothScrollTo(anchor.tops[idx] - 70 - 88);        
        setClass(idx);
      });
      // 滚动
      window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > anchorDom.offsetTop - 88) {
          anchorContentDom.setAttribute('style', 'position: fixed;');
        } else {
          anchorContentDom.removeAttribute('style');
        }
        const anchor = getAnchor();
        let idx = anchor.tops.findIndex((item) => item > window.scrollY + window.innerHeight * 0.6);
        if (idx === -1) {
          idx = anchor.tops.length;
        }
        setClass(Math.max(0, idx - 1));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!customElements.get('product-bundle')) {
    customElements.define('product-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          document.addEventListener('click', this.onOutsideClick);
          return;
        }
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        this.formatter = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency });
        this.addEventListener('change', () => this.update());
        this.addEventListener('click', event => {
          const variantButton = event.target.closest('[data-variant-id]');
          if (variantButton) {
            if (variantButton.disabled) return;
            const card = variantButton.closest('[data-card]');
            card.querySelector('select').value = variantButton.dataset.variantId;
            const picker = card.querySelector('.pb-variant');
            picker.open = false;
            this.update();
            picker.querySelector('summary').focus();
            return;
          }
          const button = event.target.closest('[data-action]');
          if (button) {
            if (!button.disabled) this.add(button.dataset.action);
            return;
          }
          const card = event.target.closest('[data-card]');
          if (!card) return;
          const product = JSON.parse(card.dataset.product);
          const selectedOption = card.querySelector('select').selectedOptions[0];
          if (event.target.closest('button, input, select, option, label, details')) return;
          const link = event.target.closest('a');
          if (link) {
            if (!link.matches('.pb-card__image, .pb-card__title') || event.target !== link) return;
            event.preventDefault();
          }
          const checkbox = card.querySelector('input[type="checkbox"]');
          if (!checkbox || checkbox.disabled) return;
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.addEventListener('toggle', event => {
          if (!event.target.matches('.pb-variant[open]')) return;
          this.querySelectorAll('.pb-variant[open]').forEach(picker => {
            if (picker !== event.target) picker.open = false;
          });
        }, true);
        this.addEventListener('keydown', event => {
          const picker = event.target.closest('.pb-variant');
          if (picker && event.key === 'Escape') {
            picker.open = false;
            picker.querySelector('summary').focus();
            event.preventDefault();
          }
        });
        this.onOutsideClick = event => {
          this.querySelectorAll('.pb-variant[open]').forEach(picker => {
            if (!picker.contains(event.target)) picker.open = false;
          });
        };
        document.addEventListener('click', this.onOutsideClick);
        this.update();
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onOutsideClick);
      }
      money(value) {
        const format = this.config.moneyFormat;
        const placeholder = /\{\{\s*(\w+)\s*\}\}/;
        const match = format?.match(placeholder);
        if (!match) return this.formatter.format(value / 100);
        const formats = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_with_space_separator: [2, ' ', '.'],
          amount_with_apostrophe_separator: [2, "'", '.'],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_no_decimals_with_space_separator: [0, ' ', '.'],
          amount_no_decimals_with_apostrophe_separator: [0, "'", '.'],
          amount_with_period_and_space_separator: [2, ' ', '.']
        };
        const options = formats[match[1]];
        if (!options) return this.formatter.format(value / 100);
        const [precision, thousands, decimal] = options;
        const parts = (value / 100).toFixed(precision).split('.');
        const amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands)
          + (parts[1] ? decimal + parts[1] : '');
        const template = document.createElement('template');
        template.innerHTML = format.replace(placeholder, amount);
        return template.content.textContent;
      }
      update() {
        let total = 0, compare = 0;
        this.items = [];
        this.querySelectorAll('[data-card]').forEach(card => {
          const select = card.querySelector('select');
          const option = select.selectedOptions[0];
          const checkbox = card.querySelector('input');
          const available = option.dataset.available === 'true';
          checkbox.disabled = !available;
          if (!available) checkbox.checked = false;
          card.classList.toggle('is-selected', checkbox.checked);
          card.classList.toggle('is-unavailable', !available);
          select.disabled = false;
          const picker = card.querySelector('.pb-variant');
          if (picker) {
            picker.querySelector('[data-variant-label]').textContent = option.textContent;
            picker.removeAttribute('aria-disabled');
            picker.querySelector('summary').tabIndex = 0;
            picker.querySelectorAll('[data-variant-id]').forEach(button => {
              button.setAttribute('aria-pressed', String(button.dataset.variantId === option.value));
            });
          }
          const price = Number(option.dataset.price), original = Number(option.dataset.compare);
          card.querySelector('[data-price]').textContent = this.money(price);
          card.querySelector('[data-compare]').textContent = this.money(original);
          card.querySelector('[data-compare]').hidden = original <= price;
          const discount = card.querySelector('[data-discount]');
          discount.hidden = original <= price;
          discount.textContent = original > price ? `${Math.round((original - price) / original * 100)}%OFF` : '';
          if (checkbox.checked) {
            total += price; compare += original;
            const existing = this.items.find(item => item.id === option.value);
            if (existing) existing.quantity += 1;
            else this.items.push({ id: option.value, quantity: 1 });
          }
        });
        this.querySelector('[data-total]').textContent = this.money(total);
        this.querySelector('[data-total-compare]').textContent = this.money(compare);
        this.querySelector('[data-total-compare]').hidden = compare <= total;
        const savings = this.querySelector('[data-savings]');
        savings.hidden = compare <= total;
        savings.textContent = `${this.config.saveLabel} ${this.money(compare - total)}`;
        this.querySelectorAll('[data-action]').forEach(button => {
          button.disabled = Boolean(this.busy) || !this.items.length;
          button.setAttribute('aria-busy', String(Boolean(this.busy)));
        });
      }
      async add(action) {
        if (this.busy || !this.items.length) return;
        const items = this.items.map(item => ({ ...item }));
        this.busy = true; this.update();
        const status = this.querySelector('[data-status]');
        status.textContent = '';
        let added = false;
        try {
          const response = await fetch(`${this.dataset.root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items, sections: ['mini-cart'], sections_url: location.pathname })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
          added = true;
          if (action === 'checkout') {
            const form = document.createElement('form');
            form.method = 'post'; form.action = this.dataset.cart;
            const checkout = document.createElement('input');
            checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = '1';
            form.append(checkout); document.body.append(form); form.submit(); return;
          }
          const responseCart = await fetch(`${this.dataset.root}cart.js`);
          if (!responseCart.ok) throw new Error(this.dataset.error);
          const cart = await responseCart.json();
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
          const html = result.sections?.['mini-cart'];
          const parsed = html ? new DOMParser().parseFromString(html, 'text/html') : null;
          if (window.themeVariables?.settings.cartType !== 'drawer' || !document.querySelector('cart-drawer') || !parsed?.querySelector('cart-drawer')) {
            location.assign(this.dataset.cart); return;
          }
          cart.sections = result.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: true } }));
        } catch (error) {
          if (added) { location.assign(this.dataset.cart); return; }
          status.textContent = error.message || this.dataset.error;
        } finally { this.busy = false; this.update(); }
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-image-card"] && !Shopify.designMode) return;
  try {
    
  if (!window.productImageCardCopyBound) {
    window.productImageCardCopyBound = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-pic-copy]');
      if (!button) return;
      const status = button.closest('.pic-code').querySelector('[role="status"]');
      try {
        await navigator.clipboard.writeText(button.dataset.picCopy);
        status.textContent = button.dataset.success;
      } catch (error) { status.textContent = button.dataset.failure; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-text-card"] && !Shopify.designMode) return;
  try {
    
  if (!window.bfTextCardTooltipsInitialized) {
    window.bfTextCardTooltipsInitialized = true;

    document.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch') return;
      const details = event.target.closest('.bf-text-cards__details');
      if (details) details.open = true;
    });

    document.addEventListener('pointerout', (event) => {
      if (event.pointerType === 'touch') return;
      const details = event.target.closest('.bf-text-cards__details');
      if (details && !details.contains(event.relatedTarget) && !details.contains(document.activeElement)) {
        details.open = false;
      }
    });

    document.addEventListener('focusin', (event) => {
      const details = event.target.closest('.bf-text-cards__details');
      if (details) details.open = true;
    });

    document.addEventListener('focusout', (event) => {
      const details = event.target.closest('.bf-text-cards__details');
      if (details && !details.contains(event.relatedTarget)) details.open = false;
    });

    document.addEventListener('click', (event) => {
      document.querySelectorAll('.bf-text-cards__details[open]').forEach((details) => {
        if (!details.contains(event.target)) details.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const details = event.target.closest('.bf-text-cards__details');
      if (details) {
        details.querySelector('summary').focus();
        details.open = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!window.bfTimelineInitialized) {
    window.bfTimelineInitialized = true;

    const updateTimelines = () => {
      document.querySelectorAll('.bf-timeline[data-auto-progress="true"]').forEach((timeline) => {
        const stages = Array.from(timeline.querySelectorAll('.bf-timeline__step'));
        let activeIndex = -1;

        stages.forEach((stage, index) => {
          const value = stage.dataset.startTime.trim();
          if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(value)) return;
          const startTime = Date.parse(value);
          if (Number.isFinite(startTime) && Date.now() >= startTime) activeIndex = index;
        });

        stages.forEach((stage, index) => {
          stage.classList.toggle('is-active', index <= activeIndex);
          if (index === activeIndex) {
            stage.setAttribute('aria-current', 'step');
          } else {
            stage.removeAttribute('aria-current');
          }
        });
      });
    };

    updateTimelines();
    document.addEventListener('shopify:section:load', updateTimelines);
    document.addEventListener('visibilitychange', updateTimelines);
    window.setInterval(updateTimelines, 1000);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!window.slideshowLoginGuardInitialized) {
    window.slideshowLoginGuardInitialized = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-slideshow-login-required]');
      if (!button) return;
      const content = button.closest('.content-box');
      const notice = content && content.querySelector('[data-slideshow-login-notice]');
      if (!notice) return;
      event.preventDefault();
      notice.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      const loginLink = notice.querySelector('a');
      if (loginLink) loginLink.focus();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
